import React, { useEffect, useState } from "react";
import { Badge, Calendar, Spin } from "antd";
import ModalItemCalendarList from "./modal/modalItemCalendarList";
import { db } from "../firebase/firebase"; // Import Firestore setup
import { collection, query, getDocs } from "firebase/firestore";
import dayjs from "dayjs";

const getTime = (value) => {
  return value.split(' ')[1]
}

const getCalendarLabel = (value) => {
  return getTime(value.meetStartDate) + ' - ' + getTime(value.meetEndDate) + ' ' + value.content
}

const getMonthData = (value) => {
  if (value.month() === 8) {
    return 1394;
  }
};

const fetchEventDataForMonth = async (year, month) => {

  const eventQuery = query(collection(db, "meetings"));

  const querySnapshot = await getDocs(eventQuery);
  let events = [];

  querySnapshot.forEach((doc) => {
    const data = doc.data();
    events.push({
      id: doc.id,
      eventName: data.eventName,
      meetEndDate: data.meetEndDate,
      meetStartDate: data.meetStartDate,
      remark: data.remark,
      createAt: data.createAt,
    });
  });

  events.sort(
    (a, b) =>
      dayjs(a.meetStartDate, "DD/MM/YYYY HH:mm") -
      dayjs(b.meetStartDate, "DD/MM/YYYY HH:mm")
  );

  return events;
};

export const BookingPage = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState({ year: 2025, month: 0 }); // Start with January 2025
  const [selectedDate, setSelectedDate] = useState(null); // วันที่ที่เลือก
  const [loading, setLoading] = useState(false); // แสดงสถานะโหลดข้อมูล
  const [loadingCalendar, setLoadCalendar] = useState(false); // แสดงสถานะโหลดข้อมูล

  useEffect(() => {
    setLoading(true);
    const loadEventsForMonth = async () => {
      const eventData = await fetchEventDataForMonth(
        selectedMonth.year,
        selectedMonth.month
      );
      setEvents(eventData);
      setLoading(false);
    };

    loadEventsForMonth();
  }, [selectedMonth, loadingCalendar]);

  const getListData = (value) => {
    const listData = events.filter((event) => {
      const eventStartDate = dayjs(event.meetStartDate, "DD/MM/YYYY HH:mm");
      const eventEndDate = dayjs(event.meetEndDate, "DD/MM/YYYY HH:mm");

      return (
        eventStartDate.date() === value.date() &&
        eventStartDate.month() === value.month() &&
        eventStartDate.year() === value.year()
      );
      return event;
    });
    return listData.map((event) => ({
      ...event,
      type: "success",
      content: `${event.eventName}`,
    }));
  };

  const monthCellRender = (value) => {
    const num = getMonthData(value);
    return num ? (
      <div className="notes-month">
        <section>{num}</section>
        <span>Backlog number</span>
      </div>
    ) : null;
  };

  // const dateCellRender = (value) => {
  //   const listData = getListData(value);
  //   return (
  //     <ul style={{ backgroundColor: "blue" }} className="events">
  //       {listData.map((item) => (
  //         <li key={item.content}>
  //           <Badge status={"success"} text={item.content} />
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  const priorityColors = {
    low: "#e2faaf", //"#d6f09e",//"#c9e391", // สีเขียวอ่อน
    medium: "#fff3cd", // สีเหลืองอ่อน
    high: "#f8d7da", // สีแดงอ่อน
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    const taskCount = listData.length;
    if (taskCount === 0) return null;

    let priority = "low"; // ค่าเริ่มต้นเป็น low
    if (taskCount === 2) priority = "medium";
    if (taskCount >= 3) priority = "high";
    return (
      <div
        style={{
          backgroundColor: priorityColors[priority],
          borderRadius: "10px",
          padding: "5px",
          minHeight: "40px",
        }}
        className="events"
      >
        {listData.map((item) => (
          <li key={item.content}>
            <Badge status="success" text={getCalendarLabel(item)} />
          </li>
        ))}
      </div>
    );
  };

  const cellRender = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    if (info.type === "month") return monthCellRender(current);
    return info.originNode;
  };

  const customHeaderRender = ({ value, type, onChange, onTypeChange }) => {
    const handlePrev = (e) => {
      e.stopPropagation();
      const newDate = value.clone().subtract(1, "month");
      onChange(newDate);
      setSelectedMonth({ year: newDate.year(), month: newDate.month() });
    };

    const handleNext = (e) => {
      e.stopPropagation();
      const newDate = value.clone().add(1, "month");
      onChange(newDate);
      setSelectedMonth({ year: newDate.year(), month: newDate.month() });
    };

    return (
      <div className="custom-header">
        <button className="nav-button" onClick={handlePrev}>
          ‹
        </button>
        <span className="header-text">{value.format("MMMM YYYY")}</span>
        <button className="nav-button" onClick={handleNext}>
          ›
        </button>
      </div>
    );
  };

  const onSelectDate = async (value, event) => {
    console.log("value", value, event);

    if (event.source === "customize") {
      return;
    }
    const formattedDate = dayjs(value).format("DD/MM/YYYY");
    setSelectedDate(formattedDate);
    setIsModalOpen(true);
  };

  return (
    <div className="text-center">
      <div className="row">
        <Spin spinning={loading}>
          <Calendar
            onSelect={onSelectDate}
            cellRender={cellRender}
            headerRender={customHeaderRender}
            mode="month"
          />
        </Spin>
      </div>
      <ModalItemCalendarList
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        selectedDate={selectedDate}
        setLoadCalendar={setLoadCalendar}
      />
    </div>
  );
};
